<div class="sir-container">
    <input
        #input
        class="sir-text-style-paragraph-m-default"
        type="text"
        autocapitalize="none"
        [placeholder]="placeholderKey | translate"
        [attr.aria-label]="placeholderKey | translate"
        [formControl]="control"
        (keydown.enter)="submit()"
        data-cy="search-input" />
    @if (busy | async) {
        <sirius-spinner data-cy="search-spinner"></sirius-spinner>
    } @else {
        @if (!control.value) {
            <sirius-icon [name]="'magnifying_glass'" aria-hidden="true" data-cy="search-magnifying-glass-icon"></sirius-icon>
        } @else {
            <sirius-icon
                class="sir-clear-icon"
                [name]="'x'"
                (click)="clear()"
                data-cy="search-clear-icon"></sirius-icon>
        }
    }
</div>
